import { useEffect, useState } from 'react';

import {
  NETCHEX_NEW_NAV_BODY_CLASS,
  NETCHEX_NEW_NAV_COLLAPSED_BODY_CLASS,
  isNetchexLogin,
} from 'constants/netChexConstants';

export const useIsNetchexNewNavAndAdminOrManagerPage = () => {
  // todo: is admin or manager page part cause this new nav is applicable to only admin and manager pages
  // issue: how to know of the internal page that we are on, for eg review form is through manager/employee login?
  const [hasClass, setHasClass] = useState({ hasSidebarClass: false, hasSidebarCollapsedClass: false });

  useEffect(() => {
    if (!isNetchexLogin) return () => {};
    const checkClass = () => {
      const hasSidebarClass = document.body.classList.contains(NETCHEX_NEW_NAV_BODY_CLASS);
      const hasSidebarCollapsedClass = document.body.classList.contains(NETCHEX_NEW_NAV_COLLAPSED_BODY_CLASS);
      setHasClass({ hasSidebarClass, hasSidebarCollapsedClass });
    };

    checkClass(); // Initial check
    const observer = new MutationObserver(checkClass);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect(); // Cleanup
  }, [isNetchexLogin]);

  return {
    isNetchexNewSideNav: hasClass.hasSidebarClass,
    isNetchexNewSidePanelCollapsed: hasClass.hasSidebarCollapsedClass,
  };
};
